import { render, staticRenderFns } from "./ProductSectors.vue?vue&type=template&id=eebb0a70&"
import script from "./ProductSectors.vue?vue&type=script&lang=ts&"
export * from "./ProductSectors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports